import React, { useEffect } from "react";
//GraphQL
import { useMutation, gql } from "@apollo/client";
//Router
import { useParams } from "react-router-dom";

const CountWorkplacesReady = ({ setFrameTarjet }) => {
  setFrameTarjet("count-to-print-workplaces");

  const { id } = useParams();

  const getMutation = () => {

    return gql`
    mutation updateOrderCount{
      updateOrderCount(id: ${parseInt(id)}, isCount: true) {
          id
        }
      }
  `;
  };
  // eslint-disable-next-line
  const [executeMutation, { data, error }] = useMutation(getMutation());

  useEffect(() => {
    executeMutation();
    // eslint-disable-next-line
  }, []);
  return <></>;
};

export default CountWorkplacesReady;